import { Loader } from '@/components/primitives/Loader';

/**
 * FullPageLoader Component
 * Centered full-screen loading spinner overlay.
 * Used for auth checks and route transitions.
 */
export const FullPageLoader = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Loader size="l" />
  </div>
);
